import { useEffect, useState } from 'react';
import { getUserHasFeature } from 'services/featureFlagr';

export const useTms = () => {
  const [hasTmsCteAcces, setHasTmsCteAccess] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getUserHasFeature(String(process.env.FLAG_TMS));
      setHasTmsCteAccess(response.access);
    };

    fetchData();
  }, []);

  return { hasTmsCteAcces };
};
